<template>
    <div>
        <vueper-slides :dragging-distance="50">
            <vueper-slide v-for="(slide, i) in slides" :key="i" :image="slide.image" :title="slide.title"
                :content="slide.content" :link="slide.link" />
        </vueper-slides>
        <vueper-slides :dragging-distance="70" prevent-y-scroll>
            <vueper-slide v-for="(slide, i) in options" :key="i" :image="slide.image" content="Drag the slide horizontally..."
                :style="'background-color: ' + ['#ff5252', '#42b983'][i % 2]">
                <template #content>
                    <div class="vueperslide__content-wrapper">
                        <div class="vueperslide__title">a{{ i.toString() }}</div>
                        <slot name="content-custom"></slot>
                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>
    </div>
</template>
<script>
import 'vueperslides/dist/vueperslides.css';

import { VueperSlides, VueperSlide } from 'vueperslides';
export default {
    components: { VueperSlides, VueperSlide },
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            slides: [
                {
                    title: 'El Teide Volcano, Spain',
                    content: 'Photo by Max Rive',
                    // You can also provide a URL for the image.
                    image: 'https://cdn.nguyenkimmall.com/images/detailed/555/may-anh-cho-nguoi-moi.jpg',
                    link: '#'
                },
                {
                    title: 'El Teide Volcano, Spain',
                    content: 'Photo by Max Rive',
                    // You can also provide a URL for the image.
                    image: 'https://cdn.nguyenkimmall.com/images/detailed/555/may-anh-cho-nguoi-moi.jpg',
                    link: '#'
                },
                // Other slides.
            ]
        }
    }
}
</script>
